<template>
  <div
    class="popupcart"
    :class="{'vogue_popupcart':theme=='venue','showtime_popupcart':theme=='showtime','drawer':theme=='showtime'&&(cart_type=='drawer'||cart_type=='page')}"
  >
    <div class="popup_header">
      <h3 class="title_font2" v-if="cartmes.cart_contents_count || cart_type=='page' || theme=='venue'" >{{$t('venue.home.shopping_cart')}}</h3>
      <h3  class="title_font2 f_title_case" v-if="(theme=='showtime' && cart_type != 'page') && !cartmes.cart_contents_count" style="margin-top: 24px;">{{$t('showtime.home.empty_cart')}}</h3>
      <p class="page_text_font" v-if="theme=='showtime' && cart_type=='page' && !cartmes.cart_contents_count" style="padding-left:25px;">{{$t('showtime.home.empty_cart')}}</p>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true" class="iconfont iconguanbi"></span>
      </button>
    </div>
    <div class="popup_body text-uppercase clearfix" v-if="cartmes.cart_contents_count" :style="{'padding-bottom':theme=='showtime'&&cart_note_off?'50px':''}">
      <div class="cart_body">
        <v-cartitem
          v-for="item in cartmes.cart"
          :theme="theme"
          :key="item.key"
          :product="item"
          :coupons="coupons"
          @changequantity="changequantity"
          :show_currency_selector="show_currency_selector"
          :currency_style="currency_style"
          :disabled="disabled_num"
          popcart="popcart"
        ></v-cartitem>
      </div>
      <div class="foot_layout">
        <div class="clearfix">
          <div class="cart_foot">
            <p class="subtotal">
            <span class="secondary_title">{{$t('cart.subtotal')}}</span>
              <v-selectprice
                :price="complete_subtotal.toFixed(2)"
                :font-size="16"
                :disable_select="theme == 'showtime'?'true':!show_currency_selector"
                :currency_style="currency_style"
                type="reverse"
                :appendToBody="false"
                :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
              ></v-selectprice>
            </p>
            <p v-if="cartmes.discount_cart" class="savetotal">
            <span class="secondary_title">{{$t('cart.saving')}}</span>
              <v-selectprice
                :price="(cartmes.discount_cart-0).toFixed(2)"
                :font-size="16"
                :disable_select="true"
                :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
                type="reverse"
                :appendToBody="false"
              ></v-selectprice>
            </p>
          </div>
          <div class="shopping-carbody-list-foot-tip">
            {{ $t("cart.Taxes_shipping_checkout") }}
          </div>
          <div class="checkbtn"
            :style="{
             filter:  checkout_active ? 'opacity(60%)' : ''
            }">
            <a
              v-if="theme=='showtime'"
              :href="`/checkouts/${cart_hash}`"
              @click.prevent="toCheckout"
              :style="checkout_active?'opacity: 0.5;pointer-events:none':''"
            >
              <p class="checkbtn_box main_button">
                <span class="iconfont icongouwuche"></span>
                <span class="add-to-cart-text secondary_title">{{$t('cart.check_out')}}</span>
              </p>
            </a>
            <a
              v-if="theme=='venue'"
              :href="`/checkouts/${cart_hash}`"
              @click.prevent="toCheckout"
              class="shakeMe main_button secondary_title"
              style="width:100%"
            >
            {{$t('cart.check_out')}}</a>
          </div>
          <v-paypal-btn
            v-if="theme=='showtime'&&cart_type=='page'&&paypal_enabled&&paypal_enabled!='none'"
            style="float:right;width:200px;margin-top:20px;position:relative;z-index: 1;"
            :cartmes="JSON.stringify(cartmes)"
          ></v-paypal-btn>
        </div>
        <div class="note_box">
          <v-cartnote style="width:100%;margin-top: -11px;" v-if="cart_note_off" :cart_note="this.cartmes.cart_note"  :wrap_class="theme=='showtime'?'cart_note_page':''" :note_content_style="theme=='venue'?{width:'100%'}:''"></v-cartnote>
        </div>
      </div>
    </div>
    <div class="empty_cart text-uppercase" v-else>
      <p class="page_text_font f_title_case" v-if="theme=='showtime'" style="text-align:left;font-size:14px">
        {{$t('showtime.cart.continue_browsing')}}
        <a class="page_text_font" style="display:inline" href="/collections/all">{{$t('cart.cart_here')}}</a>
        .
      </p>
      <template v-if="theme=='venue'">
        <h5 class="page_text_font">{{$t('cart.cart_empty')}}</h5>
        <span class="iconfont iconkonggouwuche"></span>
        <a class="shakeMe main_button secondary_title" href="/collections/all">{{$t('venue.cart.shop_now')}}</a>
      </template>
    </div>
    <div :style="{'margin-bottom':theme=='showtime'?'50px':''}">
    <v-guess-like
      :comment="comment"
      v-if="recommended_product && show_recommended && got_cartmes"
      :recommended_product="recommended_product"
      :cart_type="cart_type"
      :hide_container="false"
      :product_id="product_ids"
      :show_currency_selector="show_currency_selector"
      :theme="theme"
      :palette_config="palette_config"
      :card_type="card_type"
    ></v-guess-like>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vCartitem from "./cartitem";
import vGuessLike from '@/js/components/view/guesslike/guesslike';
import vCartnote from "@/js/components/common/cartnote.vue";
export default {
  props: [
    "comment",
    "show_currency_selector",
    "pixel_conversion",
    "theme",
    "cart_type",
    "cart",
    "currency_style",
    "cart_note_off",
    "paypal_enabled",
    "recommended_product",
    "palette_config",
  ],
  data() {
    return {
      cartmes: {},
      cart_hash: null,
      coupons: [],
      disabled_num: false,
      checkout_active: false,
      show_recommended: false,
      got_cartmes:false
    };
  },
  async beforeMount() {
    console.log("购物车 popcart",this.cart_type,this.theme);
    if(this.theme=='showtime'&&this.cart_type=='page'){
      console.log(this.theme,this.cart_type);
      this.cart_notices(this.cart,this);
    }

    if (
      !window.fbq &&
      this.pixel_conversion &&
      this.pixel_conversion.pixel_conversion
    ) {
      this.FBevent();
    }
    if (this.cart_type == "page" && this.theme == "showtime") {
      this.cart_hash = this.getCookie("cart_hash");
      this.cartmes = this.cart;
      this.getCoupon(this.cart.coupons);
      this.$store.dispatch("change_news_cart",  this.cart);
      this.$store.dispatch("cartContentsCount", this.cart.cart_contents_count);
      localStorage.setItem("cartContentsCount", this.cart.cart_contents_count);
      this.got_cartmes = true;
    } else {
      try {
        let res = await this.$axios.get(API.addcart);
        this.cartmes = res.data;
        this.got_cartmes = true;
        this.getCoupon(res.data.coupons);
        this.$store.dispatch("change_news_cart",  res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        // if (res.data.cart_contents_count) {
        //   this.$(".header-trigger-right .cartdot").show();
        // } else {
        //   this.$(".header-trigger-right .cartdot").hide();
        // }
        // this.$(".header-trigger-right .cart span").html(
        //   "(" + res.data.cart_contents_count + ")"
        // );
      } catch (error) {
        if (
          error?.response?.data?.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    }
  },
  methods: {
    toCheckout() {
      this.checkout_active = true;
      let cart_item = Object.values(this.cartmes.cart);
      let content_ids = [];
      let product_category_ids = [];
      cart_item.forEach(item => {
        content_ids.push(item.product_id);
        if (item.category_ids) {
          product_category_ids = product_category_ids.concat(item.category_ids);
        }
      });
      if (window.fbq) {
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        this.send_fb_event('InitiateCheckout',{
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD"
        })
      }
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('InitiateCheckout')
      }
      if (window._learnq) {
        this.klaviyo_checkout(this.cartmes)
      }
      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href },
      });
      this.$axios.post(API.statis_event, {
        name: "checkout.check",
        parameters: { url: window.location.href }
      });
      // if (window.gtag) {
      //   window.gtag("event", "cart.check");
      // }
      // if (window.snaptr) {
      //     window.snaptr('track', 'START_CHECKOUT', {
      //         'currency': this.cartmes.currency ? this.cartmes.currency : "USD",
      //         'item_category': null,
      //         'item_ids': this.content_ids,
      //         'number_items': this.cartmes.cart_contents_count,
      //         'price': this.cartmes.cart_total,
      //     })
      // }
      this.cart_hash = this.getCookie("cart_hash");
      setTimeout(() => {
        this.checkout_active = false;
      }, 5000);
      this.toCheckInfo(this.cart_hash);
      // window.open(`/checkouts/${this.cart_hash}`,'_self')
    },
    getCoupon(oldCoupons) {
      if (Object.prototype.toString.call(oldCoupons) === "[object Object]") {
        this.coupons = Object.values(oldCoupons);
      } else {
        this.coupons = [];
      }
    },
    async changequantity(quantity, key, product_id, variant_id) {
      if(this.disabled_num) return;
      this.disabled_num = true;
      let product_argument = variant_id
        ? { quantity, product_id, variant_id }
        : { quantity, product_id };
      try {
        var res = await this.$axios.put(
          API.changequantity + key,
          {...product_argument,tag:'store'}
        );
        this.disabled_num = false;
        this.cartmes = res.data;
        this.getCoupon(res.data.coupons);
        this.$store.dispatch("change_news_cart", res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
      } catch (error) {
        this.disabled_num = false;
        if (
          error?.response?.data?.errors
        ) {
          this.$message({message:Object.values(error.response.data.errors)[0][0], type:'error', customClass:'message-zindex__error' });
        } else if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    }
  },
  mounted(){
    if (this.recommended_product) {
      this.show_recommended = this.recommended_product.shopCart==1;
    }
  },
  computed: {
    product_ids(){
      if (!this.cartmes.cart) return;
      let products=Object.values(this.cartmes.cart);
      let ids=[];
      if(!products.length) return '';
      products.forEach(item=>{
        ids.push(item.product_id);
      })
      return ids.join(',');
    },
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    },
    ...mapState({
      card_type: ({ options }) => options?.theme?.global?.product_cart?.card_radio,
    }),
  },
  components: {
    vCartitem,
    vGuessLike,
    vCartnote,
  },
  watch: {
    "$store.state.news_cart"(news_cart) {
      this.cartmes = news_cart;
      this.getCoupon(news_cart.coupons);
      console.log(this.cartmes);
    }
  }
};
</script>
<style scoped lang='scss'>
.popupcart {
  background-color: #ffffff;
  width: 100%;
  pointer-events: auto !important;
  .popup_header {
    background: #f0f0f0;
    position: relative;
    h3 {
      // line-height: 54px;
      padding: 18px 0 18px 25px;
      text-align: left;
      font-size: 22px;
      font-family: Oswald-Regular, Oswald;
      font-weight: 400;
      color: #111111;
      letter-spacing: 1px;
      margin: 0;

    }
    button {
      position: absolute;
      top: 8px;
      right: 15px;
      margin: 0;
      line-height: 54px;
      padding: 0 10px;
      cursor: pointer;
    }
  }
  .popup_body {
    padding: 24px 12px;
    padding-top:0;
    & > .shakeMe {
      width: 100%;
    }
    .cart_body {
      padding: 0 12px;
      border-bottom: 1px solid #e4e4e4;
      margin: 24px 0;
    }
    .cart_foot {
      width: 100%;
      margin-bottom: 16px;
      .subtotal {
        width: 100%;
        text-align: right;
        font-size: 16px;
        margin: 0;
        color: #111;
        line-height: 35px;
        font-family: "Oswald", sans-serif;
        font-weight: 400;
        letter-spacing: 1px;
      }
      .savetotal {
        text-align: right;
        line-height: 30px;
        font-size: 16px;
        padding-right: 2px;
      }
    }
  }
  .empty_cart {
    text-align: center;
    padding: 24px;
    h5 {
      color: #111;
      font-family: "Oswald", sans-serif;
      font-weight: 400;
      letter-spacing: 1px;
      margin-bottom: 0;
    }
    span {
      font-size: 80px;
      line-height: 100px;
      height: 100px;
      width: 100px;
      display: inline-block;
      margin: 18px 0;
      color: #e4e4e4;
    }
    a {
      display: inline-block;
      width: 100%;
    }
  }
}
.drawer {
  background: none;
  .popup_header {
    background: none !important;
    button {
      display: none !important;
    }
  }
}
.showtime_popupcart {
    &::v-deep .guess_like {
     .guess_list_wrap{
       .prev{
          left: -17px;
       }
       .next{
         right: -14px;
       }
     }
   }
  .empty_cart {
    padding-top: 0px;
    a {
      color: #9c756f;
    }
  }
  .popup_header {
    background: #fff;
    h3 {
      font-family: "Times New Roman", Times, serif;
      font-weight: 700;
      font-size: 18px;
      text-align: left;
      color: #858585;
      text-transform: Capitalize;
      @media screen and(max-width: 768px) {
        & {
          width: 85%;
        }
      }
    }
  }
  .popup_body {
    .cart_body {
      padding-top: 18px;
      border-top: 1px solid #e4e4e4;
      max-height: 712px;
      overflow-y:auto;
      .pro_title {
        text-align: left !important;
      }
      .cartitem {
        .item_num {
          .product_qty {
            button {
              display: none;
            }
            input {
              border: none;
              background: #fff;
            }
          }
        }
        .item_num:hover {
          .product_qty {
            button {
              display: inline-block;
            }
            input {
              border: 1px solid;
              background: red;
            }
          }
        }
      }
    }

    .cart_foot {
      position: relative;
      .subtotal {
        width: 100% !important;
      }
      .savetotal {
        text-align: right;
      }
    }

    .checkbtn {
      a{
        .checkbtn_box {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0;
          height: 44px;
        }
      }
      text-align: right;
      .shakeMe {
        width: 150px;
      }
    }
  }
}
.vogue_popupcart{
  &::v-deep .guess_like .guess_list_wrap>{
    button{
      width: 38px;
      height: 38px;
      svg{
        height: 13px;
      }
    }
    .prev{
      left: -10px;
    }
    .next{
      right: -17px;
    }
  }
}
.checkbtn:hover {
filter: opacity(80%);
}

@media screen and(max-width: 768px) {
  .popupcart {
    .popup_body {
      padding:0;
      .foot_layout {
        display: flex;
        justify-items: center;
        flex-direction: column-reverse;
        padding:0 12px;
        .checkbtn {
          margin-bottom: 12px;
        }
        .cart_foot {
          p {
            display: flex;
            justify-content: space-between;
          }
          .subtotal {
            width: 100%;
            text-align: center;
          }
        }
        .note_box{
          position: relative;
          width: 100%;
        }
        .checkoutbox {
          .checkout {
            width: 100%;
          }
        }
      }
    }
    .popup_header h3 {
      padding-left: 12px;
    }
  }
  .showtime_popupcart {
    .cart_foot {
      p {
        display: flex;
        justify-content: space-between;
      }
      .subtotal {
        text-align: right !important;
      }
    }
  }
  .drawer {
    margin-top: 50px;
  }
}
@media screen and(min-width: 768px) {
  .foot_layout {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    padding:0 12px;
    .note_box{
      &::v-deep .note_wrap {
        .note_content {
          textarea {
            height: 100px;
          }
        }
      }
      position: relative;
      width: calc(100% - 300px);
      max-width: 420px;
    }
    .checkbtn {
      width: 240px;
      float: right;
    }
  }
}
.shopping-carbody-list-foot-tip {
  text-align: right;
  text-transform: initial;
  word-wrap: break-word;
  font-size: 14px;
  line-height: 1.5;
  margin: -5px 0 20px 0;
}
</style>
<style>
#modalCart{
  z-index: 9999999999;
}
.message-zindex__error {
  z-index: 10000000000 !important;
}
</style>
